import React, { Component } from 'react';
import { Container } from 'flux/utils';
import TableView from '../Common/TableView';
import SystemTaskStore from '../../stores/SystemTaskStore';
import SystemTaskActions from '../../actions/SystemTaskActionCreator';
import SystemTaskRow from './SystemTaskRow';

class SystemTasks extends Component {
    componentDidMount() {
        SystemTaskActions.getTasks();
    }

    render()  {
        const headers = ["service", "schedule", "repeat", "active", ""];
        return <TableView
            title="Background Tasks"
            headers={headers}
            rows={this.state.tasks}
            decorator={SystemTaskRow}
        />;
    };
}

SystemTasks.getStores = () => ([SystemTaskStore]);
SystemTasks.calculateState = prevState => ({
    ...prevState,
    isFetching: SystemTaskStore.isFetching(),
    tasks: SystemTaskStore.getAll(),
});

export default Container.create(SystemTasks);
